export default {
    user: null,
    users: []
};
